module.exports = __webpack_public_path__ + "img/side-rwlb.ff51f70f.png";